interface HumanReviewValue {
  output_type: string
  float_value: number | null
  string_value: string | null
  set_value: string[] | null
}

interface SimulationIdentity {
  simulationOutputId: string
}

export function getHumanReviewValue(review: HumanReviewValue): string | null {
  if (review.output_type === "float") {
    return review.float_value !== null ? String(review.float_value) : null
  }
  if (review.output_type === "string") {
    return review.string_value
  }
  if (review.output_type === "set") {
    return review.set_value && review.set_value.length > 0
      ? review.set_value.join(", ")
      : null
  }
  return null
}

export function formatDate(dateString: string | null): string | null {
  if (!dateString) {
    return null
  }
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  } catch {
    return null
  }
}

export function extractSimulationIds(data: SimulationIdentity[]): string[] {
  return data.map((item) => item.simulationOutputId)
}
